var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.accepted)?_c('div',{staticClass:"cookie-layer"},[_c('div',{staticClass:"cookie-layer__card"},[_c('div',{staticClass:"cookie-layer__copy",domProps:{"innerHTML":_vm._s(_vm.copy)}}),_c('button',{staticClass:"cookie-layer__button",on:{"click":_vm.onAccept}},[_vm._v(" "+_vm._s(_vm.btnLabel)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }